import React, { useCallback, useState } from "react";
import ko from "knockout";
import { useStyles } from "./styles";
import ReportQueueControls from "./ReportQueueControls";

const ReportQueueControlsWrapper = ({ reportName, currentUser, reportQueueService, enqueueSnackbar, history }) => {
  const formatList = [
    { value: 0, label: 'PDF' },
    { value: 1, label: 'XLS' },
    { value: 2, label: 'XLSX' },
    { value: 3, label: 'RTF' },
    { value: 4, label: 'DOCX' },
    { value: 5, label: 'MHT' },
    { value: 6, label: 'HTML' },
    { value: 7, label: 'Text' },
    { value: 8, label: 'CSV' },
    { value: 9, label: 'Image' },
  ];

  const [exportFormat, setExportFormat] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const classes = useStyles();

  const handleSubmitToQueue = useCallback(async () => {
    setIsSubmitting(true);
    try {
      const rawModel = ko.dataFor(document.querySelector(".viewport"));
      const symbols = Object.getOwnPropertySymbols(rawModel.viewerModel);
      const latestValueSymbol = symbols.find((s) => s.toString() === "Symbol(_latestValue)");
      const previewModel = rawModel.viewerModel[latestValueSymbol];
      const parametersModel = previewModel?.parametersModel;

      if (parametersModel) {
        const submittedParams = {};
        const parameterList = parametersModel._parameters;

        parameterList.forEach((param) => {
          if (typeof param.value === "function") {
            submittedParams[param.path] = param.isMultiValue && typeof param._value === "function"
              ? param._value()
              : param.value();
          } else {
            submittedParams[param.path] = param.value;
          }
        });

        const jobRequest = {
          reportName,
          requestedBy: currentUser.UserID,
          parameters: submittedParams,
          exporttype: formatList[exportFormat].label,
        };

        const result = await reportQueueService.addReportJob(jobRequest);
        if (result.status === 200) {
          enqueueSnackbar("Report job submitted successfully", {
            variant: "success",
            tag: "JobSubmissionSuccess",
          });
          setTimeout(() => {
            history.push("/reportqueue");
          }, 1000);
        }else {
          console.error("Job submission failed with non-200 status", result);
          enqueueSnackbar("Failed to submit a report job", {
            variant: "error",
            tag: "JobSubmissionFailed",
          });
          setIsSubmitting(false);
        }
      }
    } catch (error) {
      console.error("Job submission failed", error);
      enqueueSnackbar("Failed to submit a report job", {
        variant: "error",
        tag: "JobSubmissionFailed",
      });
      setIsSubmitting(false);
    }
  }, [exportFormat, reportName, currentUser, reportQueueService, enqueueSnackbar, history]);

  return (
    <ReportQueueControls
      exportFormat={exportFormat}
      setExportFormat={setExportFormat}
      formatList={formatList}
      onSubmit={handleSubmitToQueue}
      classes={classes}
      disabled={isSubmitting}
    />
  );
};

export default ReportQueueControlsWrapper;
